export const CHANGE_LOADING = '[EXERCISES] CHANGE_LOADING'
export const CHANGE_PAGINATION = '[EXERCISES] CHANGE_PAGINATION'
export const GET_EXERCISE = '[EXERCISES] GET_EXERCISE'
export const GET_LAST_SEEN_EXERCISE = '[EXERCISES] GET_LAST_SEEN_EXERCISE'
export const LIST_FREE_AND_PRIVATE_EXERCISES = '[EXERCISES] LIST_FREE_AND_PRIVATE_EXERCISES'
export const SEEN_EXERCISE = '[EXERCISES] SEEN_EXERCISE'
